import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './PrivacyPolicy.scss';

function DrewnikaPrivacy() {
  return (
    <>
      <Helmet>
        <title>Drewnika Privacy Policy | Valendris</title>
        <meta
          name="description"
          content="Privacy policy for the Drewnika app: what it stores, how it is used, and how to delete it."
        />
      </Helmet>
      <section className="privacy-policy">
        <div className="privacy-policy-container container">
          <h1 className="privacy-policy-title">Drewnika Privacy Policy</h1>
          <p className="privacy-policy-updated">Last updated: August 2026</p>

          <div className="privacy-policy-content">
            <div className="privacy-policy-section">
              <p className="privacy-policy-text">
                Drewnika is an app for logging how you and the people you eat and watch
                things with rate movies, meals, desserts, and coffee. This policy covers
                the Drewnika mobile app specifically.
              </p>
            </div>

            <div className="privacy-policy-section">
              <h2 className="privacy-policy-section-title">Information We Collect</h2>
              <p className="privacy-policy-text">
                <strong>Account information.</strong> Your email address and password,
                used only to sign you in. Passwords are handled by our authentication
                provider (Supabase) and stored hashed &mdash; we never see or store your
                plain password. You also choose a display name, which you can change at
                any time.
              </p>
              <p className="privacy-policy-text">
                <strong>Content you create.</strong> The names of the people you add as
                raters, the movies and food you log (including their titles and the
                optional location you type in), and the star ratings and optional notes
                each person gives.
              </p>
            </div>

            <div className="privacy-policy-section">
              <h2 className="privacy-policy-section-title">What We Do Not Collect</h2>
              <ul className="privacy-policy-list">
                <li>No advertising identifiers, and no advertising</li>
                <li>No analytics or usage tracking</li>
                <li>
                  No location data &mdash; the &ldquo;where&rdquo; field is free text you
                  type yourself; the app never reads your device&rsquo;s location
                </li>
                <li>No access to contacts, photos, camera, or microphone</li>
                <li>No payment information; the app is free and has no purchases</li>
              </ul>
            </div>

            <div className="privacy-policy-section">
              <h2 className="privacy-policy-section-title">How We Use It</h2>
              <p className="privacy-policy-text">
                Your information is used solely to operate the app: to sign you in and
                show you your own entries. We do not sell, rent, or share your data with
                third parties, and we do not use it for advertising or profiling.
              </p>
            </div>

            <div className="privacy-policy-section">
              <h2 className="privacy-policy-section-title">Where It Is Stored</h2>
              <p className="privacy-policy-text">
                Data is stored in a Supabase project hosted on Amazon Web Services.
                Access is protected by row-level security, which restricts every record
                to the account that created it. Traffic between the app and the server is
                encrypted in transit.
              </p>
            </div>

            <div className="privacy-policy-section">
              <h2 className="privacy-policy-section-title">A Shared Sign-In With Rankful</h2>
              <p className="privacy-policy-text">
                Drewnika shares its sign-in system with Rankful, another Valendris app.
                One account works for both. Signing up in either app creates a single
                account usable in both, and{' '}
                <strong>deleting your account removes it from both apps</strong>, along
                with all data in each. The app warns you about this before you confirm.
                The two apps keep their data separate; neither can read the
                other&rsquo;s entries.
              </p>
            </div>

            <div className="privacy-policy-section">
              <h2 className="privacy-policy-section-title">Deleting Your Data</h2>
              <p className="privacy-policy-text">
                You can permanently delete your account and everything in it at any time
                from <strong>Profile &rarr; Delete account</strong> inside the app. You
                will be asked for your password to confirm. Deletion is immediate and
                cannot be undone.
              </p>
              <p className="privacy-policy-text">
                If you can no longer sign in, you can{' '}
                <Link to="/drewnika/account-deletion-request" className="privacy-policy-link">
                  request deletion here
                </Link>{' '}
                and we will process it within 30 days.
              </p>
            </div>

            <div className="privacy-policy-section">
              <h2 className="privacy-policy-section-title">Children</h2>
              <p className="privacy-policy-text">
                Drewnika is not directed at children under 13 and we do not knowingly
                collect information from them.
              </p>
            </div>

            <div className="privacy-policy-section">
              <h2 className="privacy-policy-section-title">Contact</h2>
              <p className="privacy-policy-text">
                Questions or requests about your data:{' '}
                <a href="mailto:contact@valendris.com" className="privacy-policy-link">
                  contact@valendris.com
                </a>
                , or{' '}
                <Link to="/contact" className="privacy-policy-link">
                  use the contact form
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default DrewnikaPrivacy;
